/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Popover, TextField, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import theme from '../../../../../Shared/Themes/theme';
import { wrapperStyles } from '../AllJobs.Style';

const DayCircle = ({ day, selected, onClick }: { day: number; selected: boolean; onClick: () => void }) => (
  <Box
    onClick={onClick}
    sx={{ ...wrapperStyles.dayCircleStyle, backgroundColor: selected ? theme.palette.primary.main : 'transparent' }}>
    <Typography>{day}</Typography>
  </Box>
);

const DaySelectionGrid = ({
  control,
  name,
  isScheduleCreation,
  setSelectedDate,
}: {
  control: any;
  name: string;
  isScheduleCreation?: boolean;
  setSelectedDate?: (val: string) => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { textField } = wrapperStyles;
  const { t } = useTranslation(['jobManagement']);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const selectedDay = parseInt(field.value, 10);

        const handleClick = (event: React.MouseEvent<HTMLElement>) => {
          setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
          setAnchorEl(null);
        };

        const open = Boolean(anchorEl);

        return (
          <>
            <TextField
              sx={{
                ...textField,
                width: '22.5rem',
                marginRight: '1.5rem',
                marginBottom: isScheduleCreation ? '2rem' : '',
              }}
              label={t('jobManagement:dayOfMonth')}
              value={field.value || ''}
              onClick={handleClick}
              fullWidth
              inputProps={{ readOnly: true }}
            />
            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}>
              <Box
                sx={{
                  p: 2,
                  display: 'grid',
                  gridTemplateColumns: isScheduleCreation ? 'repeat(7, 1fr)' : 'repeat(6, 1fr)',
                  gap: 1,
                }}>
                {Array.from({ length: 31 }, (_, i) => {
                  const day = i + 1;
                  return (
                    <DayCircle
                      key={day}
                      day={day}
                      selected={selectedDay === day}
                      onClick={() => {
                        field.onChange(day.toString().padStart(2, '0'));
                        setSelectedDate?.(day.toString().padStart(2, '0'));
                        handleClose();
                      }}
                    />
                  );
                })}
              </Box>
            </Popover>
          </>
        );
      }}
    />
  );
};

export default DaySelectionGrid;
